<template lang='pug'>
    crud-form( read-only ref='form' reset-text='refrescar' :show-labels='false' v-bind='formProps' @reset='reset' )
        template( slot='headersButton' )
            v-btn( color='info' @click='submitPurchaseTaxDocumentPendingList' ) ir a documentos por pagar
                v-icon.ml-2 call_made
            v-btn( color='info' @click='submitPurchaseTaxDocumentList' ) ir a documentos de compra
                v-icon.ml-2 call_made
        template( slot='slot-table' v-if='invoice_number' )
            crud-data-table( no-data-text='Sin ordenes de compra.' no-pagination no-remove no-tools show-native-pagination title='Ordenes de compra' v-bind='tableProps' @detail='submitDetail' )
</template>

<script>
//
import { mapActions } from 'vuex'
import { CrudForm } from '@/components/reusable_components'
import { ModelDataTable as CrudDataTable } from '@/components/reusable_components/next'
//
import PurchaseInvoiceService from '@/services/api/purchase/purchase-invoice'
import PurchaseOrderService from '@/services/api/purchase/purchase-order'
//
export default {
    components: {
        CrudDataTable,
        CrudForm,
    },
    computed: {
        /**
         *
         */
        formProps() {
            return {
                fields: PurchaseInvoiceService.fieldsDetail,
                formTitle: this.invoice_number
                    ? 'Factura de compra #' + this.invoice_number
                    : '',
                loading: this.loading,
            }
        },

        /**
         *
         */
        paramFilter() {
            return {
                invoice_number: this.invoice_number,
            }
        },

        /**
         *
         */
        tableProps() {
            return {
                headers: PurchaseInvoiceService.headersDetail,
                paramFilter: this.paramFilter,
                service: PurchaseOrderService,
            }
        },
    },
    data() {
        return {
            invoice_number: null,
            loading: false,
        }
    },
    methods: {
        //
        ...mapActions('MenuesModule', {
            setTitleTopBar: 'setTitleTopBar',
        }),

        /**
         *
         */
        async reset() {
            //
            const purchaseInvoice = await PurchaseInvoiceService.fetchById(
                this.$route.params.id
            )

            //
            this.$refs.form.setValue(
                'business_name',
                purchaseInvoice.pch_provider.business_name
            )
            this.$refs.form.setValue('rut', purchaseInvoice.pch_provider.rut)
            this.$refs.form.setValue(
                'address',
                purchaseInvoice.pch_provider_branch_offices.address
            )
            this.$refs.form.setValue(
                'invoice_number',
                purchaseInvoice.invoice_number
            )

            //
            this.$refs.form.setValue(
                'emission_date',
                purchaseInvoice.emission_date
            )
            this.$refs.form.setValue(
                'payment_date',
                purchaseInvoice.payment_date
            )
            this.$refs.form.setValue(
                'accounting_date',
                purchaseInvoice.accounting_date
            )

            //
            this.$refs.form.setValue(
                'acc_cost_center_id',
                purchaseInvoice.acc_cost_center_id
            )
            this.$refs.form.setValue(
                'pch_payment_condition_id',
                purchaseInvoice.pch_payment_condition_id
            )
            this.$refs.form.setValue('iva', purchaseInvoice.iva)
            this.$refs.form.setValue(
                'new_subtotal',
                purchaseInvoice.new_subtotal
            )
            this.$refs.form.setValue('total', purchaseInvoice.total)

            //
            this.invoice_number = purchaseInvoice.invoice_number
        },

        /**
         *
         */
        submitDetail(event) {
            this.$router.push({
                name: 'purchase-orders-detail',
                params: { id: event.item.id },
            })
        },

        /**
         *
         */
        submitPurchaseTaxDocumentList() {
            this.$router.push({ name: 'purchase-tax-documents-list' })
        },

        /**
         *
         */
        submitPurchaseTaxDocumentPendingList() {
            this.$router.push({ name: 'purchase-invoices-paid-list' })
        },
    },
    beforeMount() {
        this.reset()
    },
    mounted() {
        this.setTitleTopBar('Detalle de factura de compra')
    },
    beforeRouteEnter(to, from, next) {
        next(ctx => {
            if (!ctx.$can('VIEW_DETAIL_PURCHASE_INVOICE')) ctx.$router.push('/')
        })
    },
}
</script>